import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import AdminNavbar from './AdminNavbar';
import { Outlet, useLocation, Navigate } from 'react-router-dom';

export default function AdminLayout() {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [currentPage, setCurrentPage] = useState('Dashboard');
  const location = useLocation();

  // Get user data
  const getUserData = () => {
    try {
      const userData = localStorage.getItem('user');
      return userData ? JSON.parse(userData) : null;
    } catch (error) {
      return null;
    }
  };

  const user = getUserData();
  const userRole = user?.role || 'user';

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  // Check if current route is accessible for user role
  const isRouteAccessible = () => {
    if (userRole === 'admin') return true;
    
    // Regular users can only access blogs
    const allowedRoutes = ['/admin/blogs'];
    return allowedRoutes.includes(location.pathname);
  };

  // Update current page title based on route
  useEffect(() => {
    const pageTitles = {
      '/admin/dashboard': 'Dashboard',
      '/admin/services': 'Services',
      '/admin/projects': 'Projects',
      '/admin/products': 'Products',
      '/admin/blogs': 'Blogs',
      '/admin/users': 'Users',
      '/admin/categories': 'Categories',
      '/admin/careers': 'Careers',
      '/admin/careers/applications': 'Career Applications'
    };

    setCurrentPage(pageTitles[location.pathname] || 'Dashboard');
  }, [location.pathname]);

  if (!isRouteAccessible()) {
    return <Navigate to="/admin/blogs" replace />;
  }

  return (
    <div className="admin-layout">
      <Sidebar isCollapsed={isSidebarCollapsed} />
      <AdminNavbar 
        isSidebarCollapsed={isSidebarCollapsed} 
        toggleSidebar={toggleSidebar}
        currentPage={currentPage}
      />
      <div className={`admin-content ${isSidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
        <Outlet />
      </div>
    </div>
  );
}